// extracted by mini-css-extract-plugin
export var checkbox = "_2j-0";
export var circle = "_2j-3";
export var horizontalContainer = "_2j-7";
export var sm = "_2j-5";
export var switch0 = "_2j-2";
export var switchDisabled = "_2j-8";
export var switchEnabled = "_2j-1";
export var textSwitchContainer = "_2j-9";
export var textSwitchOption = "_2j-a";
export var textSwitchOptionSelected = "_2j-b";
export var verticalContainer = "_2j-6";
export var xs = "_2j-4";